var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _c("div", { staticClass: "task-progress" }, [
      _c(
        "div",
        { staticClass: "dtc progress-bar" },
        [
          _c("div", { staticClass: "task-stage" }, [
            _vm._v("\n        " + _vm._s(_vm.stageText) + "\n      "),
          ]),
          _c("KLinearLoader", {
            attrs: { type: "indeterminate", delay: true },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }